module.exports = new __parcel__URL__("BackgroundImg.3345d794.svg").toString();